import { FormArrayRow, FormArrayRowProps } from 'src/components/Form';
import { getMappingConfigFilterFields } from './SolutionMappingEditFormFields';
import {
  useAssetMappingAdx,
  useSolutionMappingFileDestinationOptions,
} from '../../redux';

function SolutionMappingConfigEditFormRow({
  childFields,
  update,
  values,
  ...rest
}: FormArrayRowProps) {
  const [destinationOptions, loadingDestinationOptions] =
    useSolutionMappingFileDestinationOptions();
  const [adxColumnsData, loadingAdxColumns] = useAssetMappingAdx();
  return (
    <FormArrayRow
      childFields={getMappingConfigFilterFields(
        destinationOptions,
        loadingDestinationOptions,
        adxColumnsData,
        loadingAdxColumns
      )}
      {...rest}
    />
  );
}

export default SolutionMappingConfigEditFormRow;
